import React, { createRef } from "react";
import NormalSpin from "../../../base/basicComponents/spin";
import tlReviewService from "../../../service/tlReviewService";
import { dataStatus, actions } from "../../publicDictionaryValues";
import reasonEditDefaultIcon from "../../../assets/image/reasonEditIcon.png";
import styles from "../procedureFileProcess/style/index.module.scss";
import ProcessBase from "../../commonComponents/processBase/index";
import TlReviewPending from "./tlReviewPendingPage";
import TlReviewComplete from "./tlReviewCompletePage";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import TLReviewStepService from "../../../service/tlReviewService/tLReviewStepService";
import StepService from "../../../service/stepBase/StepService";

const procedureReplaceFileRef = createRef();
const procedureRef = createRef();
const procedureServerPathRef = createRef();
const procedureSavedInRef = createRef();
const approvePageRef = createRef();

export default class TlReviewProcess extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.setGlobalVariables();
    this.initTlReviewProcedureFileState();
    // @ts-ignore
    this.procedureFileStepID = null;
    // @ts-ignore
    this.savedInReturnReasonLog = [];
    // @ts-ignore
    this.serverPathReturnReasonLog = [];
    // @ts-ignore
    this.initProcedureTableData = [];
  }

  handleTlReviewPageState = () => {
    return {
      isSaveDisabled: false,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      procedureID: null,
      procedureProcessId: null,
      procedureStepID: null,
      procedureStatus: null,
      requestByID: null,
      requestByName: null,
      receiveDate: null,
      procedureStepStatus: null,
      uploadProcedureFileNum: 0,
      procedureFileNum: 0,
      currentRole: null,
      actionName: null,
      loading: false,
      rejectReason: null,
      rejectStatus: null,
      procedureFolder: {},
      procedureNote: "",
    };
  };

  initTlReviewProcedureFileState = () => {
    this.state = {
      pageState: this.handleTlReviewPageState(),
      initTableDate: {},
      isReturnReasonLogOpen: false,
      ppoList: [],
      supportingTableData: [],
      jbProcedureSavedIn: null,
      fileTableData: [],
      taskInfoData: {},
      procedureInfoData: {},
      procedureFileData: {},
      shareTaskData: {},
      tlReviewData: {},
      // @ts-ignore
      savedInSectionState: this.initSavedInSectionState,
      // @ts-ignore
      serverPathSectionState: this.initServerPathSectionState,
      // @ts-ignore
      procedureFileTableState: this.initProcedureFileTableState,
    };
  };

  setTlReviewSavedInSectionState = (result: any) => {
    return {
      ...this.state.savedInSectionState,
      isSavedInApproveBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID:
        result.procedureFolder?.procedureSaveInCategoryStatusID || null,
      savedInReturnReasonInputValue:
        result.procedureFolder?.procedureSaveInCategoryReturnReason || null,
      savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      isSavedInReturned:
        result.procedureFolder?.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  setTlReviewServerPath = (result: any) => {
    return {
      ...this.state.serverPathSectionState,
      isServerPathReturned: result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue:
        result.procedureFolder?.clientServerPathReturnReason || null,
      serverPathValue: result.procedureFolder?.clientServerPath || null,
      isServerPathApproveBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled:
        result.procedureFolder?.clientServerPathStatusID === dataStatus.return,
      clientServerPathStatusID: result.procedureFolder?.clientServerPathStatusID || null,
      clientServerPathStatusName: result.procedureFolder?.clientServerPathStatusName || null,
      clientServerPath: result.procedureFolder?.clientServerPath || "",
    };
  };

  setTlReviewSavedInServerPathState = (result: any) => {
    this.setState({
      savedInSectionState: this.setTlReviewSavedInSectionState(result),
      serverPathSectionState: this.setTlReviewServerPath(result),
    });
  };

  setTlReviewSavedInReturnReasonLog = (item: any, index: any) => {
    if (
      item.procedureSaveInCategoryStatusID === dataStatus.return &&
      item.actionID === actions.return
    ) {
      // @ts-ignore
      this.savedInReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.procedureSaveInCategoryReturnReason,
      });
    }
  };

  setTlReviewServerPathReturnReasonLog = (item: any, index: any) => {
    if (item.clientServerPathStatusID === dataStatus.return && item.actionID === actions.return) {
      // @ts-ignore
      this.serverPathReturnReasonLog.push({
        key: index,
        returnedBy: item.auditedByName,
        returnDate: this._formateDate(item.modifiedDate),
        returnReasonColumn: item.clientServerPathReturnReason,
      });
    }
  };

  setTlReviewSavedInAndServerPathReturnReasonLog = (list: any) => {
    list.sort((a: any, b: any) => {
      return b.modifiedDate.localeCompare(a.modifiedDate);
    });
    list.forEach((item: any, index: any) => {
      this.setTlReviewSavedInReturnReasonLog(item, index);
      this.setTlReviewServerPathReturnReasonLog(item, index);
    });
  };

  initTlReviewServerPathSectionState = (result: any) => {
    // @ts-ignore
    this.initServerPathSectionState = {
      // @ts-ignore
      ...this.initServerPathSectionState,
      ...this.buildTlReviewServerPathSectionState(result.procedureFolder),
    };
  };

  initTlReviewSavedInSectionState = (result: any) => {
    // @ts-ignore
    this.initSavedInSectionState = {
      // @ts-ignore
      ...this.initSavedInSectionState,
      ...this.buildTlReviewSavedInSectionState(result.procedureFolder),
    };
  };

  initTlReviewPrimitiveServerPathSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveServerPathSectionState = {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      ...this.buildTlReviewServerPathSectionState(lastStepHistoryData),
    };
  };

  initTlReviewPrimitiveSavedInSectionState = (lastStepHistoryData: any) => {
    // @ts-ignore
    this.primitiveSavedInSectionState = {
      // @ts-ignore
      ...this.primitiveSavedInSectionState,
      ...this.buildTlReviewSavedInSectionState(lastStepHistoryData),
    };
  };

  setInitTlReviewProcedureTableData = () => {
    // @ts-ignore
    this.procedureTableData.forEach((item: any) => {
      // @ts-ignore
      this.initProcedureTableData.push({
        data: JSON.parse(JSON.stringify(item.data)),
        checked: item.checked,
        isApproveDisabled: item.isApproveDisabled,
        isReturnDisabled: item.isReturnDisabled,
        isReturned: item.isReturned,
        isError: item.isError,
        replaceRef: item.replaceRef,
        attachmentEditIcon: reasonEditDefaultIcon,
        isDelete: false,
        isUpdate: false,
      });
    });
  };

  setTlReviewProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      const historyList = result.procedureFolder?.stepHistoryList.sort((x: any, y: any) =>
        y.modifiedDate.localeCompare(x.modifiedDate)
      );

      this.initTlReviewServerPathSectionState(result);

      this.initTlReviewSavedInSectionState(result);

      if (historyList.length !== 0) {
        const lastStepHistoryData = historyList[0];
        this.initTlReviewPrimitiveServerPathSectionState(lastStepHistoryData);
        this.initTlReviewPrimitiveSavedInSectionState(lastStepHistoryData);
      }

      // @ts-ignore
      this.procedureFileStepID = result.procedureFolder.procedureFileStepID;
      this.setProcedureTableData(result.procedureFolder);
      this.setInitTlReviewProcedureTableData();

      this.setState({
        // @ts-ignore
        fileTableData: this.procedureTableData,
        jbProcedureSavedIn:
          result.procedureFolder === null ? null : result.procedureFolder.jbProcedureSaveIn,
      });

      this.setTlReviewSavedInAndServerPathReturnReasonLog(result.procedureFolder.stepHistoryList);
      this.setTlReviewSavedInServerPathState(result);
    }
  };

  setProcedureFileData = (result: any) => {
    this.setTlReviewProcedureFileData(result);
  };

  /**
   * Build SaveIn Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildTlReviewSavedInSectionState = (data: any) => {
    return {
      savedInReturnReasonInputValue: data.procedureSaveInCategoryReturnReason,
      savedInRadioValue: data.procedureSaveInCategoryID,
      isSavedInReturned: data.procedureSaveInCategoryStatusID === dataStatus.return,
      procedureSaveInCategoryStatusID: data.procedureSaveInCategoryStatusID,
      isSavedInApproveBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.approval,
      isSavedInReturnBtnDisabled: data.procedureSaveInCategoryStatusID === dataStatus.return,
    };
  };

  /**
   * Build ServerPath Section Data From ProcedureFolder
   * @param {*} data
   * @param {*} isRevise
   * @returns
   */
  buildTlReviewServerPathSectionState = (data: any) => {
    return {
      // @ts-ignore
      ...this.primitiveServerPathSectionState,
      serverPathValue: data.clientServerPath,
      isServerPathReturned: data.clientServerPathStatusID === dataStatus.return,
      serverPathReturnReasonInputValue: data.clientServerPathReturnReason,
      clientServerPathStatusID: data.clientServerPathStatusID,
      clientServerPathStatusName: data.clientServerPathStatusName,
      clientServerPath: data.clientServerPath,
      isServerPathApproveBtnDisabled: data.clientServerPathStatusID === dataStatus.approval,
      isServerPathReturnBtnDisabled: data.clientServerPathStatusID === dataStatus.return,
    };
  };

  setSupportingFileData = (result: any) => {
    this.setSupportingTableData(result);
    this.setState({
      // @ts-ignore
      supportingTableData: this.supportingTableData,
    });
  };

  _getFlowDataSuccess = (result: any) => {
    const { procedureStepStatus } = result;
    let mergePayloadMap = undefined;

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: procedureStepStatus === "Complete",
      isShareTaskProcess: false,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    if (procedureStepStatus === "Complete") {
      TLReviewStepService.getProcedureFileStepKey = () => CompleteStepBusinessType.procedureFile;

      mergePayloadMap = StepService.getMergePayloadBySettingKey([
        CompleteStepBusinessType.procedureFile.settingKey,
      ]);
    }

    this.getInitData(
      tlReviewService.getTLReviewStepItem,
      "Get Procedure Files Failed",
      undefined,
      result,
      {
        ...mergePayloadMap,
        ...StepService.getMergePayloadBySettingKey([CompleteStepBusinessType.taskInfo.settingKey]),
      }
    );
  };

  _getFlowDataFailed = () => {
    this._alertError("Get tlReview Flow Data Failed");
  };

  getFlowData = () => {
    const parentPageData = this._getRoutingParam("ParentPage");
    const param = {
      // @ts-ignore
      taskID: this.taskID,
      // @ts-ignore
      procedureID: this.procedureID,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      parentPage: parentPageData,
    };

    tlReviewService.getFlowStepData(param, this._getFlowDataSuccess, this._getFlowDataFailed);
  };

  componentDidMount() {
    this.getFlowData();
  }

  /* function about get data from procedure file table */
  tlReviewReturnFileDataValue = (name: any, index: any) => {
    // @ts-ignore
    const procedureFileData = procedureRef.current.getDataList();
    // @ts-ignore
    let deleteList = procedureRef.current.getDeleteList();
    let combineDatalist = procedureFileData.concat(deleteList);
    return combineDatalist[index].data.find((item: any) => item.name === name);
  };

  setTlReviewServerPathObj = () => {
    let serverPathValue = null;
    let serverPathStatus = null;
    let serverPathReturnReasonInputValue = null;

    if (procedureServerPathRef.current !== null) {
      const serverPathState =
        // @ts-ignore
        procedureServerPathRef.current.state.serverPathSectionState;
      serverPathValue = serverPathState.serverPathValue;
      serverPathStatus = serverPathState.serverPathStatus;
      serverPathReturnReasonInputValue = serverPathState.serverPathReturnReasonInputValue;
    }

    return {
      serverPathReturnReasonInputValue: serverPathReturnReasonInputValue,
      serverPathValue: serverPathValue,
      serverPathStatus: serverPathStatus,
    };
  };

  tlReviewSubmitDataPara = (fileDtos: any, actionID: any, actionName: any) => {
    const serverPathObj = this.setTlReviewServerPathObj();

    const {
      savedInRadioValue,
      procedureSaveInCategoryStatusID,
      savedInReturnReasonInputValue,
      // @ts-ignore
    } = procedureSavedInRef.current.state.savedInSectionState;
    return {
      // @ts-ignore
      procedureId: this.procedureId,
      // @ts-ignore
      workflowProcessInstanceId: this.workflowProcessInstanceId,
      procedureSaveInCategoryID: savedInRadioValue,
      procedureSaveInCategoryStatusID: procedureSaveInCategoryStatusID,
      procedureSaveInCategoryReturnReason: savedInReturnReasonInputValue,
      // @ts-ignore
      flowCategoryID: this.flowCategoryID,
      // @ts-ignore
      procedureFileStepID: this.procedureFileStepID,
      rejectReason:
        approvePageRef.current === null
          ? null
          : // @ts-ignore
            approvePageRef.current.state.pageState.rejectReason,
      // @ts-ignore
      procedureStepID: this.procedureStepID,
      clientServerPath: serverPathObj.serverPathValue,
      clientServerPathStatusID: serverPathObj.serverPathStatus,
      clientServerPathReturnReason: serverPathObj.serverPathReturnReasonInputValue,
      actionName: actionName,
      actionID: actionID,
      accountID: null,
      // @ts-ignore
      isInitial: this.isRevisePage,
      procedureFiles: fileDtos,
    };
  };

  /* function about return submit data to use in integrate trigger api */
  handleReturnSubmitData = (actionID: any, actionName: any) => {
    const fileDtos: any[] = [];
    if (procedureRef.current !== null) {
      // @ts-ignore
      const procedureFileData = procedureRef.current.getDataList();
      // @ts-ignore
      let deleteList = procedureRef.current.getDeleteList();
      let combineDatalist = procedureFileData.concat(deleteList);
      combineDatalist.forEach((item: any, index: any) =>
        fileDtos.push({
          fileID:
            this.tlReviewReturnFileDataValue("newVersion", index).fileId === null
              ? this.tlReviewReturnFileDataValue("fileId", index).value
              : this.tlReviewReturnFileDataValue("newVersion", index).fileId,
          createdDate: this.tlReviewReturnFileDataValue("uploadedDate", index).value,
          uploadBy: this.tlReviewReturnFileDataValue("uploadById", index).value,
          uploadByName: this.tlReviewReturnFileDataValue("uploadByName", index).value,
          fileName:
            this.tlReviewReturnFileDataValue("newVersion", index).value === null
              ? this.tlReviewReturnFileDataValue("fileName", index).value
              : this.tlReviewReturnFileDataValue("newVersion", index).value,
          fileKey: this.tlReviewReturnFileDataValue("fileKey", index).value,
          dataStatusID: this.tlReviewReturnFileDataValue("status", index).value,
          attachmentFileID: this.tlReviewReturnFileDataValue("attachment", index).fileId,
          attachmentName: this.tlReviewReturnFileDataValue("attachment", index).value,
          returnReason: this.tlReviewReturnFileDataValue("returnReason", index).value,
          fileTagID: this.tlReviewReturnFileDataValue("fileName", index).tagValue,
          procedureFileStepID: this.tlReviewReturnFileDataValue("procedureFileStepID", index).value,
          procedureFileID: this.tlReviewReturnFileDataValue("procedureFileID", index).value,
          note: this.tlReviewReturnFileDataValue("note", index).value,
          oldFileID:
            this.tlReviewReturnFileDataValue("newVersion", index).fileId === null
              ? null
              : this.tlReviewReturnFileDataValue("fileId", index).value,
          oldFileName:
            this.tlReviewReturnFileDataValue("newVersion", index).value === null
              ? null
              : this.tlReviewReturnFileDataValue("fileName", index).value,
          isDelete: item.isDelete,
          isUpdate: item.isUpdate,
        })
      );
    }

    return this.tlReviewSubmitDataPara(fileDtos, actionID, actionName);
  };

  handleTlReviewPageProps = () => {
    const {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureProcessId,
    } = this.state.pageState;

    return {
      receiveDate,
      requestByName,
      procedureStepStatus,
      procedureStatus,
      rejectStatus,
      currentRole,
      procedureReplaceFileRef,
      procedureProcessId,
    };
  };

  handleTlReviewSectionProps = () => {
    const { taskInfoData, procedureInfoData } = this.state;

    return {
      taskInfoData,
      procedureInfoData,
      ppoList: this.state.ppoList,
    };
  };

  handleTlReviewSavedInProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
    } = this.state.savedInSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      initSavedInStatus:
        // @ts-ignore
        this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
    };
  };

  handleTlReviewServerPathProps = () => {
    const {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
    } = this.state.savedInSectionState;
    const { clientServerPath } = this.state.serverPathSectionState;

    return {
      savedInReturnReasonInputValue,
      savedInReturnReasonValue,
      savedInReasonStatus,
      procedureSaveInCategoryStatusID,
      savedInRadioValue,
      initSavedInStatus:
        // @ts-ignore
        this.initSavedInSectionState.procedureSaveInCategoryStatusID,
      // @ts-ignore
      savedInReturnReasonLog: this.savedInReturnReasonLog,
      serverPathValue: clientServerPath,
    };
  };

  handleTlReviewParams = () => {
    return {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
      // @ts-ignore
      ProcedureFileStepID: this.procedureFileStepID,
      // @ts-ignore
      WorkflowProcessInstanceId: this.workflowProcessInstanceId,
      // @ts-ignore
      FlowCategoryID: this.flowCategoryID,
    };
  };

  handleTlReviewPendingPage = (procedureTableData: any) => {
    const { shareTaskData, tlReviewData, jbProcedureSavedIn } = this.state;

    return (
      // @ts-ignore
      <TlReviewPending
        params={this.handleTlReviewParams()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        shareTaskData={shareTaskData}
        tlReviewData={tlReviewData}
        pageProps={this.handleTlReviewPageProps()}
        sectionProps={this.handleTlReviewSectionProps()}
        savedInProps={this.handleTlReviewSavedInProps()}
        serverPathProps={this.handleTlReviewServerPathProps()}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={this.tlReviewReturnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        closePage={this.closePage}
        jbProcedureSavedIn={jbProcedureSavedIn}
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  handleTlReviewCompletePage = (procedureTableData: any) => {
    const { shareTaskData, tlReviewData, jbProcedureSavedIn } = this.state;

    return (
      // @ts-ignore
      <TlReviewComplete
        _showLoading={this._showLoading}
        _hideLoading={this._hideLoading}
        closePage={this.closePage}
        primitiveSavedInSectionState={(this as any).primitiveSavedInSectionState}
        primitiveServerPathSectionState={(this as any).primitiveServerPathSectionState}
        pageProps={{ ...this.handleTlReviewPageProps(), isDisableAll: true }}
        sectionProps={this.handleTlReviewSectionProps()}
        savedInProps={this.handleTlReviewSavedInProps()}
        serverPathProps={this.handleTlReviewServerPathProps()}
        initSavedInSectionState={(this as any).initSavedInSectionState}
        initServerPathSectionState={(this as any).initServerPathSectionState}
        initProcedureFileTableState={(this as any).initProcedureFileTableState}
        initProcedureTableData={[...(this as any).initProcedureTableData]}
        fileTableData={procedureTableData}
        supportingTableData={this.state.supportingTableData}
        shareTaskData={shareTaskData}
        tlReviewData={tlReviewData}
        params={this.handleTlReviewParams()}
        updateProcedureFileNum={this.updateProcedureFileNum}
        returnFileDataValue={this.tlReviewReturnFileDataValue}
        handleReturnSubmitData={this.handleReturnSubmitData}
        jbProcedureSavedIn={jbProcedureSavedIn}
        procedureRef={procedureRef}
        procedureSavedInRef={procedureSavedInRef}
        procedureServerPathRef={procedureServerPathRef}
        setProcedureFileData={this.setProcedureFileData}
        setSupportingFileData={this.setSupportingFileData}
        setTaskInfoData={this.setTaskInfoData}
        setProcedureInfoData={this.setProcedureInfoData}
        setShareTaskData={this.setShareTaskData}
      />
    );
  };

  setTlReviewProcedureTableData = () => {
    return JSON.parse(JSON.stringify(this.state.fileTableData));
  };

  render() {
    const { loading, procedureStepStatus, procedureFileNum, uploadProcedureFileNum } =
      this.state.pageState;

    const isPendingPage = procedureStepStatus === "Pending";
    const isCompletePage = procedureStepStatus === "Complete";

    const procedureTableData = this.setTlReviewProcedureTableData();

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          procedureFileNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {uploadProcedureFileNum}/{procedureFileNum} file
            </p>
          ) : undefined
        }
        children={
          <>
            {isPendingPage && this.handleTlReviewPendingPage(procedureTableData)}
            {isCompletePage && this.handleTlReviewCompletePage(procedureTableData)}
          </>
        }
      />
    );
  }
}
